import * as R from 'ramda';
import React from 'react';
import {defer} from 'rxjs';

import ajax from 'iss/utils/ajax';
import {runBatchOps} from 'iss/utils/batchOps';
import subscribeTo from 'iss/utils/subscriptionUtils';

export const LAST_DAY_OF_MONTH = -1;

export function getActivation(activationId) {
  return defer(() => ajax.getJson("/activation/"+activationId));
}

export function searchActivations(searchTerm, showArchived, sortFieldName, sortOrder, page, pageSize, showLoadingScreen = true) {
  const encodedSearch = encodeURIComponent(searchTerm);
  return ajax.getJson(
    `/activation/search?query=${encodedSearch}&showArchived=${showArchived ? 1 : 0}&sortFieldName=${sortFieldName}&sortOrder=${sortOrder}&page=${page}&size=${pageSize}`, {showLoadingScreen}
  );
}

export function createActivation(activation) {
  return ajax.postJson("/activation", R.evolve({location: fixActivationLocation}, activation));
}

/* Creates all the supplied activations in batch.
  Returns an observable that emits status objects in the same format as
  runBatchOps in utils/batchOps.jsx
*/
export function createActivations(activations) {
  const createOps = activations.map(activation =>
    ({operation: createActivation(activation), activation})
  );
  return runBatchOps(createOps);
}

export function archiveActivation(activationId) {
  return ajax.deleteJson("/activation/"+activationId, undefined, {resultType: 'text'});
}

export function restoreActivation(activationId) {
  return ajax.putJson(`/activation/${activationId}/restore`, undefined, {resultType: 'text'});
}

export function archiveActivations(activations) {
  const createOps = activations.map(activation =>
    ({operation: archiveActivation(activation.id), activation})
  );
  return runBatchOps(createOps);
}

export function editRecurrences(activations, recurrenceModifyCommand) {
  const createOps = activations.map(activation =>
    ({operation: editRecurrence(activation.id, recurrenceModifyCommand), activation})
  );
  return runBatchOps(createOps);
}

export function addActivationParty(activationId, partyAddCommand) {
  return ajax.postJson("/activation/"+activationId+"/parties/", partyAddCommand);
}

export function editLocation(activationId, locationDto) {
  return ajax.putJson("/activation/"+activationId+"/location/", fixActivationLocation(locationDto));
}

export function removeActivationParty(activationId, partyId) {
  return ajax.deleteJson("/activation/"+activationId+"/parties/"+partyId, undefined, {resultType: 'text'});
}

export function editRecurrence(activationId, recurrenceModifyCommand) {
  return ajax.putJson("/activation/"+activationId+"/recurrence/", recurrenceModifyCommand);
}

export function subscribeToActivation(WrappedComponent, ErrorComponent) {
  return function EvaluationActivationEditor({activationId, ...props}) {
    const SubscribedComponent = subscribeTo(getActivation(activationId), 'activation', WrappedComponent, ErrorComponent);
    return <SubscribedComponent {...props} />;
  };
}

//Activation location properties should be sent as null if they're empty
const fixActivationLocation = R.unless(R.isNil, R.map(value => value === '' ? null : value));



// WEBPACK FOOTER //
// ./modules/issFrontend/service/EvaluationActivationService.js